import { useState } from 'react';
import api from '../../utils/apis'
import { setSession } from '../../utils/session'
import "assets/css/Login.css";

const Login = (props) => {

  const [login, setLogin] = useState("");
  const [passaword, setPassaword] = useState("");
  const [msgError, setMsgError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendLogin = async (e) => {
    e.preventDefault();
    setMsgError("");
    setLoading(true);
    const response = await api({call:"login",params:{login,passaword},method:"POST"});
    if(response && response.token) {
      setSession({token: response.token, user: response.user})
      props.history.push('/admin')
    }else{
      setLoading(false);
      setMsgError(response && response.error ? response.error : "No se pudo conectar con el servidor")
    }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <form className="login-card" onSubmit={sendLogin}>
          <div className="login-logo">
            <img alt="logo" src={require("../../assets/img/brand/finanzme.png").default} />
          </div>
          <h1 className="login-title">Bienvenido</h1>
          <p className="login-subtitle">Inicia sesión para gestionar tus bots</p>

          {msgError && (
            <div className="login-error" role="alert">
              <i className="fas fa-exclamation-circle" />
              {msgError}
            </div>
          )}

          <label className="login-label" htmlFor="login-user">Usuario</label>
          <div className="login-field">
            <i className="fas fa-user" />
            <input
              id="login-user"
              type="text"
              value={login}
              onChange={(e)=>{ setLogin(e.target.value) }}
              placeholder="Tu usuario"
              autoComplete="username"
              autoFocus
            />
          </div>

          <label className="login-label" htmlFor="login-password">Contraseña</label>
          <div className="login-field">
            <i className="fas fa-lock" />
            <input
              id="login-password"
              type={showPassword ? "text" : "password"}
              value={passaword}
              onChange={(e)=>{ setPassaword(e.target.value) }}
              placeholder="Tu contraseña"
              autoComplete="current-password"
            />
            <button
              type="button"
              className="login-toggle"
              onClick={() => setShowPassword(!showPassword)}
              title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"} />
            </button>
          </div>

          <button className="login-submit" type="submit" disabled={loading || !login || !passaword}>
            {loading ? <><i className="fas fa-circle-notch fa-spin mr-2" />Entrando…</> : "Entrar"}
          </button>
        </form>
        <div className="login-footer">Finanzme · Trading bots</div>
      </div>
    </div>
  );
};

export default Login;
